"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionTypeEnum = void 0;
/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `TB` - Time Based
 * * `DB` - Session Based
 * * `TR` - Trial
 */
var SubscriptionTypeEnum;
(function (SubscriptionTypeEnum) {
    SubscriptionTypeEnum["TB"] = "TB";
    SubscriptionTypeEnum["DB"] = "DB";
    SubscriptionTypeEnum["TR"] = "TR";
})(SubscriptionTypeEnum = exports.SubscriptionTypeEnum || (exports.SubscriptionTypeEnum = {}));
